import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import * as LayerActions from '~app/actions/layers';
import defined from '~app/core/defined';

import CellDivider from './CellDivider';
import ExpandableLegend from './ExpandableLegend';
import LayerLegendCell from './LayerLegendCell';

class LayerLegend extends Component {

  getGradientInfo() {
    let gradientInfo = null;
    if (defined(this.props.activeLayer.gradientMin) &&
        defined(this.props.activeLayer.gradientMax) &&
        defined(this.props.activeLayer.gradientStyle)) {
      gradientInfo = {
        minValue: this.props.activeLayer.gradientMin,
        maxValue: this.props.activeLayer.gradientMax,
        styleName: this.props.activeLayer.gradientStyle,
      };
    }
    return gradientInfo;
  }

  renderLegendCell(legendCellData, index) {
    return (
      <div key={legendCellData.name}>
        <LayerLegendCell
          title={legendCellData.name}
          description={legendCellData.desc}
          styleName={legendCellData.style}
        />
        <CellDivider />
      </div>
    );
  }

  render() {
    return (
      <div className="LayerLegend">
        <ExpandableLegend
          title={this.props.activeLayer.name}
          description={this.props.activeLayer.desc}
          gradientInfo={this.getGradientInfo()}
          onPaddleLeft={this.props.onPaddleLeft}
          onPaddleRight={this.props.onPaddleRight}
          isBusy={this.props.isBusy}
        >
          {
            this.props.activeLayer.legendCells &&
            this.props.activeLayer.legendCells.map(::this.renderLegendCell)
          }
        </ExpandableLegend>
      </div>
    );
  }
}

LayerLegend.propTypes = {
  activeLayer: PropTypes.object,
  isBusy: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  activeLayer: state.layer.layers[state.layer.activeLayerIndex],
  isBusy: state.busy.isBusy,
});

const mapDispatchToProps = {
  onPaddleLeft: LayerActions.cycleLayerLeft,
  onPaddleRight: LayerActions.cycleLayerRight,
};

export { LayerLegend };
export default connect(mapStateToProps, mapDispatchToProps)(LayerLegend);



// WEBPACK FOOTER //
// ./src/components/LayerLegend.js